import { UsersList } from "../components/List/UsersList";
import { UsersCreate } from "../components/Create/UsersCreate";
import { UsersEdit } from "../components/Edit/UsersEdit";
import { UsersView } from "../components/View/UsersView";
import { UserOutlined } from "@ant-design/icons";
import { UserRole } from "@root/api.types";
export const USERS_LIST = {
    path: "/admin/users",
    component: UsersList,
    roles: [UserRole.ADMIN],
    menu: {
        key: "USERS_LIST",
        label: "management.users.menu.title",
        icon: UserOutlined,
    },
};
export const USERS_CREATE = {
    path: "/admin/users/create",
    roles: [UserRole.ADMIN],
    component: UsersCreate,
};
export const USERS_EDIT = {
    path: "/admin/users/:id/edit",
    roles: [UserRole.ADMIN],
    component: UsersEdit,
};
export const USERS_VIEW = {
    path: "/admin/users/:id/view",
    roles: [UserRole.ADMIN],
    component: UsersView,
};
